<template>
  <div>
    <section
      class="bg-main py-1 px-3 d-flex justify-content-center align-items-center"
    >
      <b-link
        class="material-icons align-middle text-light"
        @click="$router.go(-2)"
      >
        arrow_back
      </b-link>
      <b-input-group class="text-light my-1">
        <template v-slot:prepend>
          <b-input-group-text class="bg-main text-light">
            <i class="material-icons align-middle smaller">
              group
            </i>
          </b-input-group-text>
        </template>
        <b-form-select
          :select-size="1"
          v-model="selectedChild"
          :options="users"
          size="sm"
          class="bg-main border-0 text-light"
          variant="primary"
          @change="onChange()"
        ></b-form-select>
      </b-input-group>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    users: Array,
    onChangeAction: { type: Function },
  },
  data() {
    return {
      selectedChild: this.$route.params['childId']
    };
  },
  methods:{
    onChange(){
       this.$emit('onChangeAction', this.selectedChild);
    }
  }

};
</script>
